import React from "react";
import cssClasses from "./Experience.module.css";

const experience = () => {
    return <div className={cssClasses.Experience}>
        <iframe title="Experience" src="https://experience.d20zq6g239rc0l.amplifyapp.com/" style={{ height: "100%", width: "100%", display: "flex", justifyContent: "center", alignItems: "center", margin: "0 0 0 0" }} frameBorder="0" scrolling="no" allowfullscreen="true" webkitallowfullscreen="true" mozallowfullscreen="true"></iframe>
    </div >;
}

export default experience;